<template>
  <b-form @submit.prevent="onSubmit">
    <b-row>
      <b-col cols="12">
        <b-card no-body class="px-2 pb-4 container-card">
          <b-card-header>
            <span class="information-header">Information</span>
          </b-card-header>
          <b-skeleton-wrapper :loading="loading.bannerInfo">
            <template #loading>
              <b-row>
                <b-col cols="12">
                  <b-skeleton width="180px" height="80px" />
                </b-col>
                <b-col cols="12">
                  <b-skeleton width="75%" height="40px" />
                </b-col>
                <b-col cols="12">
                  <b-skeleton width="55%" height="140px" />
                </b-col>
                <b-col cols="12">
                  <b-skeleton width="65%" height="40px" />
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="6" class="d-flex">
                  <b-skeleton width="140px" height="30px" class="mr-1" />
                  <b-skeleton width="140px" height="30px" />
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="6" class="d-flex">
                  <b-skeleton width="140px" height="30px" class="mr-1" />
                  <b-skeleton width="140px" height="30px" />
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-skeleton width="65%" height="50px" />
                </b-col>
                <b-col cols="12">
                  <b-skeleton width="55%" height="40px" />
                </b-col>
              </b-row>
            </template>
            <div class="w-100 px-5">
              <b-row
                v-for="(field, index) in bannerForm.information.payload"
                :key="`row-${field.seq}`"
                :class="index > 0 ? 'mt-1' : null"
              >
                <b-col cols="12" md="6">
                  <component
                    :is="resolveFields(field)"
                    :ref="`${field.key}`"
                    :key="field.key"
                    :field-properties="field"
                  />
                </b-col>
              </b-row>
            </div>
          </b-skeleton-wrapper>
        </b-card>
      </b-col>
      <b-col cols="12">
        <b-card no-body class="px-2 pb-4 container-card">
          <b-card-header>
            <span class="information-header">Image or Banner</span>
          </b-card-header>
          <b-row class="px-2">
            <b-col cols="12" md="6">
              <image-uploader
                :image-url="bannerForm.image.url"
                @onUpload="onUpload"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <!-- **รอ API -->
      <!-- <b-col cols="12">
        <b-card no-body class="px-2 pb-4 container-card">
          <b-card-header>
            <span class="information-header">Tags</span>
          </b-card-header>
          <b-row class="px-2">
            <b-col cols="12" md="6">
              <b-row>
                <b-col cols="12">
                  <label for="tag-option">
                    <span>Tag</span>
                  </label>
                  <v-select
                    id="tag-option"
                    multiple
                    :options="tagOption.tag"
                    class="tag-dropdown"
                  />
                </b-col>
                <b-col cols="12" class="mt-1">
                  <label for="extra-payload">
                    <span>{{ 'Layout/Section' }}</span>
                  </label>
                  <b-form-textarea
                    :rows="3"
                    :max-rows="3"
                    placeholder="Layout/Section..."
                    class="extra-input"
                  />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
      </b-col> -->
      <b-col cols="12">
        <b-card no-body class="px-2 pb-4 container-card">
          <b-card-header>
            <span class="information-header">Assign Banner Set</span>
          </b-card-header>
          <b-row class="px-2">
            <b-col cols="12" md="6">
              <b-row>
                <b-col cols="12">
                  <v-select
                    v-model="bannerForm.assignedSetBanner"
                    multiple
                    :label="'set_name'"
                    :options="tagOption.assignSetBanner"
                    class="tag-dropdown"
                  />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col cols="12" class="d-flex justify-content-center mt-2">
        <cancel-button class="mr-1" @click.native="resolveRedirect" />
        <save-button
          class="ml-1"
          :type="'submit'"
          :btn-label="'Next'"
          :loading="loading.submit"
        />
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BButton,
  BForm,
  BFormTextarea,
  BSkeleton,
  BSkeletonWrapper,
} from "bootstrap-vue";
import Toggle from "@/views/components/dynamic-fields/components/ToggleFields.vue";
import Textbox from "@/views/components/dynamic-fields/components/TextBoxField.vue";
import TextAreaField from "@/views/components/dynamic-fields/components/TextAreaField.vue";
import Dropdown from "@/views/components/dynamic-fields/components/DropdownField.vue";
import DatePicker from "@/views/components/dynamic-fields/components/DatePickerField.vue";
import UploadIcon from "@/@core/components/svg/button/Upload.vue";
import ImageUploader from "@core/components/image-uploader/ImageUploader.vue";
import SaveButton from "@/views/components/button/SaveButton.vue";

import vSelect from "vue-select";

import useBannerCreateEditForm from "../hooks/useBannerCreateEditForm";
import CancelButton from "@/views/components/button/CancelButton.vue";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    Toggle,
    Textbox,
    TextAreaField,
    Dropdown,
    DatePicker,
    BButton,
    BForm,
    UploadIcon,
    BFormTextarea,
    ImageUploader,
    SaveButton,
    BSkeleton,
    BSkeletonWrapper,
    vSelect,
    CancelButton,
  },
  props: {
    isEdit: { type: Boolean, default: false },
    bannerId: { type: Number, default: 0 },
  },

  setup(props) {
    const {
      bannerForm,
      renderImageUrl,
      tagOption,
      loading,
      onUpload,
      resolveFields,
      onSubmit,
      resolveRedirect,
    } = useBannerCreateEditForm(props);

    return {
      bannerForm,
      renderImageUrl,
      tagOption,
      loading,
      onSubmit,
      onUpload,
      resolveFields,
      resolveRedirect,
    };
  },
};
</script>

<style></style>

<style scoped>
@import "~@/assets/css/pages/banner/banner-table.css";
@import "~@/assets/css/override-styles/tag-dropdown.css";
@import "~@/assets/css/pages/banner/create-banner.css";
</style>
